import { useState } from "react";
import classNames from "classnames";

export default function Tooltip({
  children,
  text,
  withArrow = true,
  showBelow = false,
}) {
  const [hover, setHover] = useState(false);

  const tooltipClass = classNames(
    "z-50",
    hover ? "opacity-100" : "pointer-events-none opacity-0",
    showBelow
      ? "-translate-y-[calc(-100%+6.5px)]"
      : withArrow
      ? "-translate-y-[calc(100%+14px)]"
      : "-translate-y-[calc(100%+8px)]",
    "transition-opacity duration-300",
    "fixed sm:absolute",
    "right-[3%] sm:right-auto w-[94%] sm:w-auto",
    "sm:-translate-x-[calc(50%-14px)]"
  );

  const arrowClass = classNames(
    hover ? "opacity-100" : "pointer-events-none opacity-0",
    "absolute left-[50%]",
    showBelow
      ? "-translate-y-[calc(-100%-15px)] border-b-[10px] -translate-x-[50%]"
      : "-translate-y-[calc(100%+4px)] border-t-[10px] -translate-x-[40%]",
    "border-x-[8px] border-x-transparent border-[#495057]",
    "w-0 h-0 text-sm transition-opacity duration-300"
  );

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div id="tooltip" className={tooltipClass}>
        <div
          className={classNames(
            "text-xs sm:text-vsm text-gray-1 bg-[#495057]",
            "rounded-lg shadow-sm relative py-2.5 px-4"
          )}
        >
          <p className="sm:max-w-[300px] sm:w-max text-left font-normal leading-relaxed">
            {text}
          </p>
        </div>
      </div>
      {withArrow && <div className={arrowClass}></div>}
      {children}
    </div>
  );
}
